export function formatUrl(detail = '') {
	return detail.replace(
		/((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,10}(\/\S*)?)/g,
		'<a style="color: #2AA797" href="$1" target="_blank">$1</a>'
	);
}
